import gql from 'graphql-tag'

// --- Reporting (any logged-in member) ---

export const REPORT_JOKE_MUTATION = gql`
  mutation ReportJoke($jokeId: Int!, $message: String!, $proposedRewrite: String) {
    reportJoke(jokeId: $jokeId, message: $message, proposedRewrite: $proposedRewrite) {
      report {
        id
        status
      }
    }
  }
`

export const REPORT_COMMENT_MUTATION = gql`
  mutation ReportComment($commentId: Int!, $message: String!) {
    reportComment(commentId: $commentId, message: $message) {
      report {
        id
        status
      }
    }
  }
`

// --- Admin review (staff only) ---

export const REPORTED_JOKES_QUERY = gql`
  query ReportedJokes($count: Int, $offset: Int) {
    reportedJokes(count: $count, offset: $offset) {
      reportCount
      joke {
        id
        text
        authorName
      }
      reports {
        id
        message
        proposedRewrite
        status
        createdAt
      }
    }
  }
`

export const REPORTED_COMMENTS_QUERY = gql`
  query ReportedComments($count: Int, $offset: Int) {
    reportedComments(count: $count, offset: $offset) {
      reportCount
      comment {
        id
        text
        isRemoved
        removedReason
        createdAt
      }
      reports {
        id
        message
        status
        createdAt
      }
    }
  }
`

export const ARCHIVED_JOKES_QUERY = gql`
  query ArchivedJokes($count: Int, $offset: Int) {
    archivedJokes(count: $count, offset: $offset) {
      id
      text
    }
  }
`

export const REWRITE_JOKE_MUTATION = gql`
  mutation RewriteJoke($jokeId: Int!, $newText: String!) {
    rewriteJoke(jokeId: $jokeId, newText: $newText) {
      joke {
        id
        text
      }
    }
  }
`

export const ARCHIVE_JOKE_MUTATION = gql`
  mutation ArchiveJoke($jokeId: Int!, $reason: String!) {
    archiveJoke(jokeId: $jokeId, reason: $reason) {
      joke {
        id
      }
    }
  }
`

export const REMOVE_COMMENT_MUTATION = gql`
  mutation RemoveComment($commentId: Int!, $reason: String!) {
    removeComment(commentId: $commentId, reason: $reason) {
      id
      isRemoved
      removedReason
    }
  }
`

export const DISMISS_REPORTS_MUTATION = gql`
  mutation DismissReports($jokeId: Int, $commentId: Int) {
    dismissReports(jokeId: $jokeId, commentId: $commentId) {
      ok
    }
  }
`
